module.exports = __webpack_public_path__ + "img/img2.3f6cb338.png";